import React, {useState} from "react";
// import { Button, Grid, Box } from "@mui/material";

import { useNavigate } from "react-router-dom";
// import MobileDrawer from "../MobileComponents/MobileDrawer";

// import ProfileBottomTab from "../MobileComponents/ProfileBottomTab";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CreateIcon from "@mui/icons-material/Create";
// import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import EmailIcon from "@mui/icons-material/Email";
// import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import avtar from "../../../MobileScreens/assets/images/Profile-Picture.jpg";
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
// import AttachmentIcon from '@mui/icons-material/Attachment';
import { red } from '@mui/material/colors';
import document from "../../../MobileScreens/assets/images/updated-aadhaar.png";
import Zoom from "react-medium-image-zoom";
import BackupIcon from '@mui/icons-material/Backup';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";
function MobileEditProfile() {
  const navigate = useNavigate();
  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const [passHideShow, setPassHideShow] = useState(false);

  const initialValuesChangePass = {
    old_pass: "",
    new_pass: "",
    confirm_pass: "",
  };

  const validationSchemaChangePass = Yup.object({
    old_pass: Yup.string().required("Required"),
    new_pass: Yup.string().required("Required"),
    confirm_pass: Yup.string().required("Required"),
  });

  const onSubmitChangePassword = (values) => console.log("Form Data", values);

  const initialValues = {
    first_name: "",
    last_name: "",
    age: "",
    wing:"",
    flat_no:"",
    phone_no:"",
    email:"",
    family_member:"",
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    age: Yup.string().required("Required"),
    wing: Yup.string().required("Required"),
    flat_no: Yup.string().required("Required"),
    phone_no: Yup.string().required("Required"),
    email: Yup.string().required("Required"),
    family_member: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);
  return (
    <>
    <div>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileProfile")}
        />
        <h1>Edit Profile</h1>
      </div>
    </div>
    <div className="wraperMobile">
      <div className="sectionMobile">
        <div className="famDetailsListMainMob CenterViewBtn">
          <div className="CenterImageView">
          <div className="EditProfileImageView">
              <img src={avtar} className="EditProfileImage" />
            <div className="EditIconImageView">
              <CreateIcon sx={{fontSize:20, color:'#0044ff'}}/>
              <input type='file' className='ImageEditBtn'/>
            </div>
          </div>
          </div>
          <div className="famDetailsListInrMob">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
          {(formik) => (
          <Form>
            <div className='FormView'>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="First Name"
              		placeholder="Enter first name"
              		labelclassName="inputLebal"
              		name="first_name"
              		className="titleInput"
            		/>
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Last Name"
                placeholder="Enter last name"
                labelclassName="inputLebal"
                name="last_name"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Age"
                placeholder="Enter age"
                labelclassName="inputLebal"
                name="age"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Wing"
                placeholder="Enter wing"
                labelclassName="inputLebal"
                name="wing"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Flat No"
                placeholder="Enter flat no"
                labelclassName="inputLebal"
                name="flat_no"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Phone No"
                placeholder="Enter phone no"
                labelclassName="inputLebal"
                name="phone_no"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Email"
                placeholder="Enter email"
                labelclassName="inputLebal"
                name="email"
                className="titleInput"
              />
              </div>
              <div className='lebalInputView'>
              <FormikControl
                control="input"
                type="text"
                label="Total Family Member"
                placeholder="Enter total family member"
                labelclassName="inputLebal"
                name="family_member"
                className="titleInput"
              />
              </div>
              <div className="ProfileModeView">
                <p className="ProfileModeTxt">Profile Mode</p>
                  <div className="ProfileSwitchView">
                    <p className="SwitchLabel">Public</p>
                    <Switch {...label} />
                    <p className="SwitchLabel">Private</p>
                  </div>
              </div>
              <div className='attchmentView'>
              <BackupIcon sx={{ fontSize: 30, color: '#3853ec' }} />
              <input type='file' className='fileUploadButton'/>
              <p className='checkBoxTxt'>Document's</p>
              </div>
              <div className="mobDocumentInr">
                <div className="mobDocumentPrev">
                  <Zoom>
                    <img src={document} />
                  </Zoom>
                </div>
                  <h1 className="MobUploadedtx">uploaded file</h1>
                  <CloseIcon sx={{ color: red[600], fontSize: 25 }} />
              </div>
              <button className='submitButton' type='submit'>Update</button>
            </div>
            </Form>
            )}
          </Formik>
          </div>
          
          <div className="ProfileChangePassBtnView" onClick={()=>setPassHideShow(!passHideShow)}> 
            <p className="ChangePassTxt">Change Password</p>
          </div>
          
          {passHideShow?<div className="famDetailsListInrMob">
            <Formik
            initialValues={initialValuesChangePass}
            validationSchema={validationSchemaChangePass}
            onSubmit={onSubmitChangePassword}
          >
            {(formik) => (
            <Form>
            <div className='FormView'>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="Old Password"
              		placeholder="Enter Old Password"
              		labelclassName="inputLebal"
              		name="old_pass"
              		className="titleInput"
            		/>
              </div>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="New Password"
              		placeholder="Enter New Password"
              		labelclassName="inputLebal"
              		name="new_pass"
              		className="titleInput"
            		/>
              </div>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="Confirm Password"
              		placeholder="Enter Confirm Password"
              		labelclassName="inputLebal"
              		name="confirm_pass"
              		className="titleInput"
            		/>
              </div>
              <button className='submitButton GreenBack' type='submit'>Update Password</button>
            </div>
            </Form>
            )}
          </Formik>
          </div>:null}
        </div>
      </div>
    </div>
  </>
  )
}

export default MobileEditProfile